import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, LoadingController, ToastController } from 'ionic-angular';

import { BusinessUserInvoiceProvider } from '../../providers/business-user-invoice-handler';
import { BusinessUserInvoiceDetailPage } from '../../pages/business-user-invoice-detail/business-user-invoice-detail';
import { BusinessInvoiceDetailPage } from '../../pages/business-invoice-detail/business-invoice-detail';

import { Globals } from '../../providers/globals';
import { Utils } from '../../helpers/utils';

/**
 * Generated class for the BusinessUserInvoiceListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-business-user-invoice-list',
  templateUrl: 'business-user-invoice-list.html',
})
export class BusinessUserInvoiceListPage {
	isRefreshing: boolean = false;
  isLoading: boolean = false;
  isFetchingMore: boolean = false;
  
  loadingMsg: any = "Loading...";

  page: any = 1;
  size: any = 20;
  user: any;

  lastRequestReturnedValues: boolean = false;

  list: any = [];
  hasData: boolean = true;

  constructor(
    public businessUserInvoiceProvider: BusinessUserInvoiceProvider,
    public navCtrl: NavController, 
    public toastCtrl: ToastController,
    public navParams: NavParams) {

    this.user = navParams.get('user');

    this.load(null);
  }

  doRefresh(refresher) {
    this.isRefreshing = true;
    this.page = 1;
        
    this.load(()=>{
      refresher.complete();
    })
  }    

  doInfinite(infiniteScroll){
    if(!this.lastRequestReturnedValues){
      infiniteScroll.complete();
      return;
    } 

    this.isFetchingMore = true;
    this.page++;

    this.load(()=>{
      infiniteScroll.complete();
    });
  }

  load(cb){
    this.isLoading = (!this.isRefreshing && !this.isFetchingMore) ? true : false;

    this.businessUserInvoiceProvider.getById({id: this.user.Id, page: this.page, size: this.size})
    .then((data: any)=>{
      var list = data.Data;
      
      this.hasData = (list.length == 0 && this.page == 1) ? false : true;
      this.lastRequestReturnedValues = (list.length==0) ? false : true;

      if(this.page == 1){
        this.list = list;  
      }else{
        for (var i = list.length - 1; i >= 0; i--) {
          this.list.push(list[i]);
        }          
      }
      
      this.isLoading = false;      

      if(typeof cb == "function") cb();
    })
    .catch((err)=>{
      this.isLoading = false;  

      let toast = this.toastCtrl.create({
        message: 'There was an error: ' + err,
        duration: 3000,
        position: 'bottom'
      });

      toast.present();  
    });
  }  

  viewDetail(invoice){
    this.navCtrl.push(BusinessInvoiceDetailPage, {
      invoice: invoice,
      user: this.user
    });    
  }

}



// WEBPACK FOOTER //
// ./src/pages/business-user-invoice-list/business-user-invoice-list.ts